module.exports = "/_next/static/images/game-1-intro-uv-tutorial2-222039266008a0d7094dea98d4ba5d74.png";